import { SET_REQUEST_STATUS_CODE } from '../error/constant'

export const setStatusCodeAction = (e: any) => {
  const statusCode = (e.response && e.response.status) ? e.response.status : 0;
  const payload = { statusCode: statusCode, statusMessage: e.message };
  return { type: SET_REQUEST_STATUS_CODE, ...payload };
}